/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import type { Unsubscribe } from '@amazon/vinyl-util'
import { onNavigate } from '@/router/router'
import { setRouteBaseline } from '@/viewContext'

// Feeds the current-view-context provider's per-route baseline from the router.
// Lives in `router/` (not `viewContext/`) so the pure `viewContext` leaf never
// imports the router — which would drag the router's load-time `history` access
// into every agent-schema/blackbolt consumer of the provider. Wired once at
// boot (`app.ts`); the injection direction is router → viewContext, one-way.

/** Subscribe the view-context provider to route changes. Call once at boot. */
export function startViewContextRouterFeed(): Unsubscribe {
    return onNavigate((event) => setRouteBaseline(event.current))
}
